'use strict';

define('currency',[], function () {
    var env = (window && window.navigator && window.navigator.languages && window.navigator.languages[0]) || 'en-US';

    var locale_options = {
        style: 'currency',
        currency: 'USD',
        currencyDisplay: 'symbol',
        maximumFractionDigits: 2
    };
    
    function getCurrency() {
        return mapping[locale_options.currency];
    }

    function setCurrencyByCode(currencyCode) {
        locale_options.currency = currencyCode || 'USD';
        return getCurrency();
    }

    function formatCurrency(amount) {
        if (amount === 'other') return null;

        var amt = parseFloat(amount) || 0.00;

        if (amt % 1 === 0) {
            locale_options.minimumFractionDigits = 0;
        } else {
            locale_options.minimumFractionDigits = 2;
        }

        return amt.toLocaleString(env, locale_options);
    }

    // Source: https://www.xe.com/symbols.php
    var mapping = {
        'USD': {
            'resourceName': 'USDollar',
            'code': 'USD',
            'symbol': '$'
        },
        'CAD': {
            'resourceName': 'CanadianDollar',
            'code': 'CAD',
            'symbol': '$'
        },
        'EUR': {
            'resourceName': 'Euro',
            'code': 'EUR',
            'symbol': '€'
        },
        'GBP': {
            'resourceName': 'PoundSterling',
            'code': 'GBP',
            'symbol': '£'
        },
        // The below are supported only by Oberon
        'AUD': {
            'resourceName': 'AustralianDollar',
            'code': 'AUD',
            'symbol': '$'
        },
        'HKD': {
            'resourceName': 'HongKongDollar',
            'code': 'HKD',
            'symbol': '$'
        },
        'CHF': {
            'resourceName': 'SwissFranc',
            'code': 'CHF',
            'symbol': 'CHF'
        }, 
        'DKK': {
            'resourceName': 'DanishKrone',
            'code': 'DKK',
            'symbol': 'DKK'
        }
    };

    return {
        format: formatCurrency,
        get: getCurrency,
        setByCode: setCurrencyByCode
    };
});
